(ns splash.ui.lender-portal.datadog
  "Datadog RUM for the Lender Portal"
  (:require
    ["@datadog/browser-rum" :as datadog-rum]
    [splash.ui.lender-portal.config :as config])
  (:require-macros
    [splash.ui.lender-portal.version :as version]))

(defn datadog-rum-init
  []
  (let [synthetic-pattern (js/RegExp. "(Datadog|Synthetic|HeadlessChrome|Cypress)" "i")
        user-agent        (.-userAgent js/navigator)
        client-token      (config/get-config [:dd-rum-client-token])]
    (when (and (some? client-token)
            (false? (.test synthetic-pattern user-agent)))
      (js/console.debug "Initializing Datadog RUM")
      (js/window.DD_RUM.init #js{:clientToken                         client-token
                                 :applicationId                       config/DD-RUM-APPLICATION-ID
                                 :service                             "lender-portal"
                                 :site                                "datadoghq.com"
                                 :env                                 (name (config/deployment-env))
                                 :version                             (:commit (version/get-version))
                                 :defaultPrivacyLevel                 "mask-user-input"
                                 :startSessionReplayRecordingManually true
                                 :sessionSampleRate                   100
                                 :sessionReplaySampleRate             100
                                 :tags                                {:team "Instant"}}))))

(def start-session-replay-recording
  js/window.DD_RUM.startSessionReplayRecording)

(def stop-session-replay-recording
  js/window.DD_RUM.stopSessionReplayRecording)

(defn set-global-context-property
  [key value]
  (js/window.DD_RUM.setGlobalContextProperty (name key) value))

(defn set-user-info
  [user]
  (js/window.DD_RUM.setUser (clj->js user)))

(defn report-error
  ([title e] (report-error title e nil))
  ([title e context]
   (let [cause (clj->js {:cause e})
         context (clj->js context)]
     (js/window.DD_RUM.addError (js/Error. title cause) context))))
